import { useState } from "react";

// React can't catch errors from async methods in ErrorBoundary
// https://github.com/facebook/react/issues/14981#issuecomment-468460187
const useThrowAsyncError = () => {
  const [_, setError] = useState();

  return (error: { status: number } & unknown) => {
    setError(() => {
      throw error;
    });
  };
};

export default useThrowAsyncError;
